import i18n from "@/i18n";
import moment from "moment";

export const playerScreenshotsFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "playerId",
        label: i18n.t("player.id")
    },
    {
        key: "screenshotTimestamp",
        formatter: formatDate,
        label: i18n.t("common.createdOn")
    },
    {
        key: "actions",
        label: ""
    }
];

function formatDate(date: string) {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
}
